module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAAAXNSR0IArs4c6QAAAKlJREFUOBGVk8sNgzAQBX3KiR7SUU4caSrtcI3SCV2AMPMsr/IRZtdIDwzsjFc2pJzzkzxS5yFGbOI0k5WMUYdqKzNLMJBXfeBKqDNYzFAm1YC4klPY2vYkl7AnCcEtSRd8ItkQKJ8FsyLvCjSRvWby6n/eA9lWvRkr8e/kCy5tcx/a4tLBP2xthSQtOCTx4EtJFG5KECyka5+pt4Vd9Dfeyc1miF7FiD0AFhaY/psVfm0AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./resources/images/close_1x.png
// module id = 2291
// module chunks = 0